export enum ConsentMode {
    OTP='OTP',
    Signature ='Signature',
    Declaration = 'Declaration',
    otpMotorSaveProposal='otp-MotorSaveProposal'
   
}